import Controller from '@ember/controller';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import type { ContactMergeWithModel } from 'donor-elf-web/routes/funds/fund/contacts/contact/merge/with';

export default class ContactMergeWithController extends Controller {
  @service declare router: Router;

  declare model: ContactMergeWithModel;

  handleMerged = (args: { contactIdKept: string }) => {
    this.router.transitionTo(
      'funds.fund.contacts.contact',
      args.contactIdKept,
    );
  }

  handleNotMerged = () => {
    this.router.transitionTo(
      'funds.fund.contacts.contact',
      this.model.keepContact.id,
    );
  }
}
